export default {
    'do-you-want-to-merge-the-region-with-another-region':  'Do you want to merge the region with another region',
    'do-you-want-to-merge-the-area-with-another-area': 'Do you want to merge the area with another area',
    'provinces': 'Provinces', 
    'cities': 'Cities',
    'areas': 'Areas',
    'regions': 'Regions',

    'city': 'Cities',
    'area': 'Area',
    'region': 'Region',
    'province': 'Province',
    'merge-regions': 'Merge regions',
    'merge-areas': 'Merge areas',
    'areas-in-regions': 'Areas in Regions',
    'regions-in-area': 'Regions in Area',
    'please-select-a-city': 'Please select a city.',
    'no-regions-in-this-city': 'No regions in this city',
    'areas-in-this-city': 'areas in this city.',
    'show-regions': 'show regions',
    'show-areas': 'show areas',
    'show-cities': 'show cities'
}